import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import ImageUploader from 'quill2-image-uploader';
import ImageFormat from 'scaleflow/utils/quill-extenstions/image-format';
import MarkdownFormat from 'scaleflow/utils/quill-extenstions/markdown-format';
import Quill from 'quill';
import imageResizeOptions from 'scaleflow/utils/quill-extenstions/image-resize';
import registerIfNotRegistered from 'scaleflow/utils/quill-extenstions/registerIfNotRegistered';
import IdeaValidations from 'scaleflow/validators/idea';
import type IdeaModel from 'scaleflow/models/idea';
import type SessionService from 'scaleflow/services/session';
import type OrganisationService from 'scaleflow/services/organisation';
import type IntlService from 'ember-intl/services/intl';

import imageUploadHandler from 'scaleflow/utils/quill-extenstions/image-uploader';

Quill.register('formats/image', ImageFormat, true);
registerIfNotRegistered(Quill, 'modules/imageUploader', ImageUploader);
registerIfNotRegistered(Quill, 'modules/markdown', MarkdownFormat);

export default class BacklogIdeasIdeaDescriptionController extends Controller {
  @service declare currentUser: any;
  @service declare session: SessionService;
  @service declare organisation: OrganisationService;
  @service declare intl: IntlService;

  ideaValidations = IdeaValidations;

  queryParams = ['editMode'];
  @tracked editMode = false;

  declare model: IdeaModel;

  get idea(): IdeaModel {
    return this.model;
  }

  @action
  setDelta(changeset: any, e: any): void {
    changeset.set('description', e);
  }

  @action
  handleBlur(changeset: any): void {
    //if page is not navigating away
    if (changeset.get('isPristine') === true) {
      (this as any).isDisabled = true;
    } else if (changeset.get('isValid') === true) {
      (this as any).isDisabled = false;
    } else {
      (this as any).isDisabled = true;
    }
  }

  @action
  toggleEditMode(): void {
    this.editMode = !this.editMode;
  }

  @action
  handleIdeaDescriptionSave(changeset: any): void {
    changeset.save();
    this.toggleEditMode();
  }

  @action
  handleIdeaDescriptionCancel(changeset: any): void {
    changeset.rollback();
    this.toggleEditMode();
  }

  get modules() {
    const modules: any = {};
    modules.imageUploader = {
      upload: (file: File) => {
        return imageUploadHandler(
          this.session.idToken as string,
          this.organisation.id as string,
          file,
        ).then((s3Link: string) => {
          return s3Link;
        });
      },
    };

    modules.resize = imageResizeOptions(this.intl);
    modules.markdown = true;

    const toolbarOptions = [
      ['bold', 'italic', 'strike'], // toggled buttons
      ['blockquote', 'code-block'],

      [{ header: 1 }, { header: 2 }], // custom button values
      [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
      ['link', 'image', 'clean'], // remove formatting button
    ];
    modules.toolbar = toolbarOptions;
    return modules;
  }
}
